import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Chakra imports
import {
  Flex,
  Heading,
  Table,
  TableContainer,
  Thead,
  Th,
  Tr,
  Td,
  Text,
  Tbody,
  Button,
  Badge,
  Box,
  Input,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import { BsEye } from "react-icons/bs";
import moment from "moment";
// import Pagination from "components/Pagination/pagination";
import { REPORTABLE_TYPE_COLOR, PUBLISH_STATUS_COLOR } from "constants/index";
import { getAllReport } from "service/report.service";
import { usePaginateComponent } from "components/Pagination/pagination";


export default function Report() {
  //variables
  const history = useHistory();
  const [reports, setReports] = useState([]);
  const [searchReport, setSearchReport] = useState("");
  const {pagination, setPagination, PaginationComponent, updatePagination} = usePaginateComponent()


  //methods
  const getReports = async (page) => {
    try {
      const { data } = await getAllReport(page ?? 1);

      setPagination(updatePagination(data.data));

      setReports(data.data);

      window.scrollTo({ top: 80, behavior: "smooth" });
    } catch (error) {
      console.log(error);
    }
  };

  //setup methods
  useEffect(() => {
    getReports();
  }, [searchReport]);

  //component
  // console.log('reports in before return', reports.data);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card>
        <CardHeader my={"4"}>
          {/* <Heading>report Table</Heading> */}
          <Box p={"2"} w={"full"}>
            <Input
              placeholder={"Search. . ."}
              onChange={(e) => {
                setSearchReport(e.target.value);
              }}
              textColor={"black"}
              bg={"white"}
            />
          </Box>
          <PaginationComponent pagination={pagination} getListData={getReports} />
        </CardHeader>

        <CardBody>
          <TableContainer
            overscroll={"auto"}
            maxH={"xl"}
            overflowY="scroll"
            position="relative"
            w={"full"}
          >
            <Table>
              <Thead
                position="sticky"
                top="0"
                zIndex="sticky"
                bg="gray.900"
                color="whiteAlpha.900"
              >
                <Tr>
                  {/*              reports Detail           */}
                  <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Date Created
                    </Text>
                  </Th>
                  <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Report Status
                    </Text>
                  </Th>
                  <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Report Type
                    </Text>
                  </Th>
                  <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Resource Type
                    </Text>
                  </Th>
                  <Th>
                    <Text textColor={"whiteAlpha.900"} fontSize={"x-small"}>
                      Resource Status
                    </Text>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {reports &&
                  reports.map((report, index) => {
                    return (
                      <Tr
                        textColor={"whiteAlpha.900"}
                        fontSize={"small"}
                        key={index}
                        onClick={() => {
                          history.push({
                            pathname: `/admin/report/detail`,
                            state: report,
                          });
                        }}
                        _hover={{ bg: "blue.900", cursor: "pointer" }}
                        position={"relative"}
                      >
                        {/*              Reports Detail           */}
                        <Td>
                          <Text>
                            {report?.created_at
                              ? moment(report?.created_at).format("YYYY-MM-DD")
                              : ""}
                          </Text>
                        </Td>

                        <Td>
                          <Badge
                            bg={PUBLISH_STATUS_COLOR[report?.status] ?? "black"}
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {report?.is_resolved ? (
                              <Text textColor={"green.400"}>Closed</Text>
                            ) : (
                              <Text textColor={"yellow.400"}>Open</Text>
                            )}
                          </Badge>
                        </Td>
                        <Td>{report?.report_type.name}</Td>

                        <Td>
                          <Badge
                            bg={REPORTABLE_TYPE_COLOR[report?.reportable_type] ?? "black"}
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {report?.reportable_type}
                          </Badge>
                        </Td>

                        <Td>
                          {report?.reportable?.is_active == 0 ? (
                            <Text
                              textColor={"red.400"}
                              fontWeight={"extrabold"}
                              fontSize={"lg"}
                            >
                              INACTIVE
                            </Text>
                          ) : (
                            <Text
                              textColor={"green.400"}
                              fontWeight={"extrabold"}
                              fontSize={"lg"}
                            >
                              ACTIVE
                            </Text>
                          )}
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Flex>
  );
}
